import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appRestrictToGreaterThanZero]',
})
export class RestrictToGreaterThanZeroDirective {
  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value.trim();
    const regex = /^\d*\.?\d*$/;

    if (!regex.test(inputValue)) {
      inputElement.value = '';
    }
  }
}
